"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelImageVisibilityState = exports.CollectionModelImageVisibilityStateMutator = void 0;
const id_1 = require("../../../id");
const hidden_imageVisibility_1 = require("./hidden.imageVisibility");
function makeImageVisibilityState(tag, id) {
    switch (tag) {
        case 'hidden':
            return hidden_imageVisibility_1.CollectionModelHiddenImageVisibility.state(id);
        default:
            throw new Error(`Unknown marker type: "${tag}"`);
    }
}
class CollectionModelImageVisibilityStateMutator {
    constructor(state) {
        this.state = state;
    }
    getState() {
        const collectionState = this.state.collection.state;
        const captureImageVisibilityKey = CollectionModelImageVisibilityState.captureImageVisibilityId(this.state.captureId);
        return collectionState.getFieldValue(captureImageVisibilityKey);
    }
    setState(state) {
        const collectionState = this.state.collection.state;
        const captureImageVisibilityKey = CollectionModelImageVisibilityState.captureImageVisibilityId(this.state.captureId);
        collectionState.setFieldValue(captureImageVisibilityKey, state);
    }
    create(tag, id = id_1.IkeId.generate()) {
        const state = makeImageVisibilityState(tag, id);
        return this.createWithState(state);
    }
    clear() {
        this.state = null;
    }
    createWithState(state) {
        const collectionState = this.state.collection.state;
        const captureId = this.state.captureId;
        const stateId = CollectionModelImageVisibilityState.imageVisibilityId(captureId);
        if (collectionState.fields.get(stateId) != null) {
            throw new Error(`Image Visibility "${stateId}" already exists`);
        }
        collectionState.setFieldValue(stateId, state);
        this.setState(state.id);
        return state.id;
    }
}
exports.CollectionModelImageVisibilityStateMutator = CollectionModelImageVisibilityStateMutator;
const ID_PREFIX_IMAGE_VISIBILITY = 'iv';
const ID_PREFIX_CAPTURE_IMAGE_VISIBILITY = 'civ';
class CollectionModelImageVisibilityState {
    static imageVisibilityId(captureId) {
        return `${ID_PREFIX_IMAGE_VISIBILITY}:${captureId}:image-visibility-hidden`;
    }
    static captureImageVisibilityId(captureId) {
        return `${ID_PREFIX_CAPTURE_IMAGE_VISIBILITY}:${captureId}`;
    }
    static getCaptureImageVisibilityId(key) {
        if (key.startsWith(`${ID_PREFIX_CAPTURE_IMAGE_VISIBILITY}:`)) {
            return key.substr(3);
        }
        return null;
    }
    constructor(collection, captureId) {
        this.Mutator = new CollectionModelImageVisibilityStateMutator(this);
        this.id = id_1.IkeId.generate();
        this.collection = collection;
        this.captureId = captureId;
    }
    hasImageVisibility() {
        return !!this.state;
    }
    hideForExport() {
        if (!(this.hasImageVisibility())) {
            return false;
        }
        else {
            let visibility = this.getImageVisibility();
            switch (visibility.state.tag) {
                case 'hidden':
                    const hidden = this.getImageVisibility().hidden;
                    return Boolean(hidden);
                default:
                    return false;
            }
        }
    }
    getImageVisibility() {
        let imageVisibility = this.imageVisibility;
        if (imageVisibility == null) {
            const imageVisibilityId = CollectionModelImageVisibilityState.imageVisibilityId(this.captureId);
            let imageVisibilityState = this.collection.state.getFieldValue(imageVisibilityId);
            if (imageVisibilityState == null) {
                //if we can't find a state with the current id, we recreate a new state with the same id, and query it again
                this.Mutator.create('hidden');
                imageVisibilityState = this.collection.state.getFieldValue(imageVisibilityId);
            }
            switch (imageVisibilityState.tag) {
                case 'hidden':
                    imageVisibility = new hidden_imageVisibility_1.CollectionModelHiddenImageVisibility(this, imageVisibilityId, this.captureId);
                    break;
                default:
                    throw new Error(`Capture ${this.captureId}:Unknown visibility correction type: "${imageVisibilityState.tag}"`);
            }
            this.imageVisibility = imageVisibility;
        }
        return imageVisibility;
    }
    value() {
        return this.getImageVisibility();
    }
    get capture() {
        return this.collection.state.getCapture(this.captureId);
    }
    get state() {
        return this.collection.state.getFieldValue(CollectionModelImageVisibilityState.captureImageVisibilityId(this.captureId));
    }
}
exports.CollectionModelImageVisibilityState = CollectionModelImageVisibilityState;
//# sourceMappingURL=imageVisibility.state.js.map